import { render, staticRenderFns } from "./option.vue?vue&type=template&id=08cc005c"
import script from "./option.vue?vue&type=script&lang=js"
export * from "./option.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports